export class TdsRequestApiConstants
{
    public static readonly GET_SINGLE_TDS: string = 'tds/retrieve';
    public static readonly GET_MULTIPLE_TDS: string = 'tds/retrieve-multiple';
}